"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SERVICE_STATUS = exports.APPROVE_MODE = exports.MERCHANT_EVENT = exports.SORT_ORDER = void 0;
var SORT_ORDER;
(function (SORT_ORDER) {
    SORT_ORDER["asc"] = "asc";
    SORT_ORDER["desc"] = "desc";
})(SORT_ORDER = exports.SORT_ORDER || (exports.SORT_ORDER = {}));
var MERCHANT_EVENT;
(function (MERCHANT_EVENT) {
    MERCHANT_EVENT["VIEW_TUTORIAL"] = "FIRST_TIME_ACCESS_TUTORIAL";
})(MERCHANT_EVENT = exports.MERCHANT_EVENT || (exports.MERCHANT_EVENT = {}));
var APPROVE_MODE;
(function (APPROVE_MODE) {
    APPROVE_MODE["none"] = "none";
    APPROVE_MODE["basic"] = "basic";
    APPROVE_MODE["advanced"] = "advanced";
})(APPROVE_MODE = exports.APPROVE_MODE || (exports.APPROVE_MODE = {}));
var SERVICE_STATUS;
(function (SERVICE_STATUS) {
    SERVICE_STATUS["active"] = "active";
    SERVICE_STATUS["inactive"] = "inactive";
})(SERVICE_STATUS = exports.SERVICE_STATUS || (exports.SERVICE_STATUS = {}));
